import {connect} from 'react-redux'
import Header from '../Header'
import InviteForm from './InviteForm'
import StaffList from './StaffList'
import ConfirmDeleteModal from './ConfirmDeleteModal'
import {submitForm, assignOutlets, pageRequest} from 'actions/employees/list'
import {error} from 'actions/notifications'
import {browserHistory} from 'react-router'
import NoDataAndLoading from 'components/NoDataAndLoading'
import {getFormValues} from 'redux-form'

class List extends React.Component {
  componentDidMount () {
    const {expired} = this.props.data.subscriptionExpired
    const expireTime = 365 // expire time 1 year
    if (!expired) {
      this.props.dispatch(pageRequest())
      if (Cookies.get('labelNew') === 'true') {
        Cookies.set('labelNew', 'false', { path: '/', domain: '.mokapos.com', expires: expireTime })
      }
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  render () {
    let {showDeleteEmployeeModal, deletedEmployee, employees} = this.props.data.employee.list
    let {showLoadingSpinnerPage} = this.props.data.loadingSpinner
    return (<div>
      <div className='row'>
        <div className='col-md-8 col-sm-12 col-lg-6'>
          <Header title='Invite Staff' />
          <InviteForm onSubmit={this._onSubmit} dispatch={this.props.dispatch} />
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-12'>
          <Header title='Staff List' />
          <NoDataAndLoading
            showLoadingSpinner={showLoadingSpinnerPage}
            noDataToDisplay={employees.length === 0}
            title='No Data To Display'
            description='' />
          <StaffList />
        </div>
      </div>
      {<ConfirmDeleteModal
        showDeleteEmployeeModal={showDeleteEmployeeModal}
        deletedEmployee={deletedEmployee}
        dispatch={this.props.dispatch}
      />}
    </div>)
  }

  _onSubmit = (values) => {
    const {data: {employee: {list: {profile}}}} = this.props

    let outletIds = []
    values.outlets.forEach((outlet) => {
      if (outlet.checked) {
        outletIds.push(outlet.id)
      }
    })
    // 0 is app only
    const permission = (profile.is_owner) ? values.permission : 0

    let data = {
      email: values.email.toLowerCase(),
      first_name: values.firstName,
      last_name: values.lastName,
      outlet_ids: outletIds,
      password: values.password,
      password_confirmation: values.password,
      title: values.title,
      access_type: 1, // don't know why this values is 1 either
      user_type: permission
    }
    if (outletIds.length === 0) {
      let {checkedOutlets} = this.props.data.employee.list
      this.props.dispatch(error('You must select at least 1 outlet'))
      this.props.dispatch(assignOutlets(checkedOutlets, this.props.data.inviteForm))
    } else if (data.user_type < 0 || data.user_type === undefined) {
      this.props.dispatch(error('You must select a permission for the employee'))
    } else {
      this.props.dispatch(submitForm(data, {}))
    }
  }
}

List.propTypes = {

}

function mapStateToProps (state) {
  return {
    data: {
      inviteForm: getFormValues('invite')(state),
      employee: {
        list: state.employee.list
      },
      loadingSpinner: state.loadingSpinner,
      subscriptionExpired: state.subscriptionExpired
    }
  }
}

export default connect(mapStateToProps)(List)



// WEBPACK FOOTER //
// ./app/pages/Employees/List/List.js